import { render, staticRenderFns } from "./Created.vue?vue&type=template&id=4cb9aaa3&scoped=true&"
import script from "./Created.vue?vue&type=script&lang=js&"
export * from "./Created.vue?vue&type=script&lang=js&"
import style0 from "./Created.vue?vue&type=style&index=0&id=4cb9aaa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9aaa3",
  null
  
)

export default component.exports